import CrudTable from "@/components/CrudTable";

const METRICS = {
  Revenue: "revenue",
  "Cash Flow": "net_cash_flow",
  "Tax Compliance": "tax_compliance_rate",
  "Budget Adherence": "over_budget_categories",
  "Department Profitability": "avg_dept_profitability",
  "Fund Raising": "fund_applications",
};

export default function GoalSetting() {
  const columns = [
    { key: "title", label: "Goal" },
    { key: "category", label: "Category", type: "badge" },
    { key: "metric", label: "Tracked Metric" },
    { key: "target_value", label: "Target" },
    { key: "period_type", label: "Period" },
    { key: "owner", label: "Owner" },
    { key: "outcome", label: "Outcome", type: "badge" },
  ];
  const fields = [
    { key: "title", label: "Goal Title", type: "text", required: true, full: true },
    { key: "category", label: "Category", type: "select", options: Object.keys(METRICS), required: true },
    { key: "metric", label: "Tracked Metric", type: "select", options: Object.values(METRICS), required: true },
    { key: "target_value", label: "Target Value (₹ or %)", type: "number", required: true },
    { key: "period_type", label: "Time Period", type: "select", options: ["Monthly", "Quarterly", "Custom"], required: true },
    { key: "owner", label: "Assigned Owner", type: "text", required: true },
    { key: "outcome", label: "Status", type: "select", options: ["In Progress", "Achieved", "Missed", "Revised"] },
  ];
  return (
    <CrudTable
      testid="goals"
      endpoint="goals"
      title="Goal Setting"
      subtitle="Create goals linked to real data fields — they automatically populate the Dashboard KPI scorecard. Set once, reflected everywhere."
      addLabel="Add New Goal"
      columns={columns}
      fields={fields}
      defaults={{ period_type: "Monthly", outcome: "In Progress" }}
    />
  );
}
